import { Box, Button, Dialog, DialogContent, IconButton, Stack, Typography } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

import AccountingOnboardingCompletionSVG from 'assets/img/icons/CheckLarge.svg';

interface AutoStatementsSuccessModalProps {
    readonly open: boolean;
    readonly onClose: () => void;
    readonly institutionName: string;
}

/**
 * Success modal shown after successfully enabling Auto Statements via Quiltt.
 */
export default function AutoStatementsSuccessModal({
    open,
    onClose,
    institutionName,
}: AutoStatementsSuccessModalProps) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 2,
                    p: 2,
                },
            }}>
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 16,
                    top: 16,
                    color: 'cement.700',
                    bgcolor: 'cement.100',
                    width: 36,
                    height: 36,
                    '&:hover': {
                        bgcolor: 'grey.200',
                    },
                }}>
                <CloseIcon fontSize="small" />
            </IconButton>
            <DialogContent>
                <Stack alignItems="center" spacing={3} sx={{ py: 2 }}>
                    {/* Success Icon */}
                    <Box
                        component="img"
                        src={AccountingOnboardingCompletionSVG}
                        alt="Success"
                        sx={{ width: 100, height: 'auto' }}
                    />

                    {/* Title */}
                    <Typography variant="h3" textAlign="center">
                        Auto Statements enabled
                    </Typography>

                    {/* Success Message */}
                    <Typography variant="body1" textAlign="center">
                        Success! Statements from {institutionName} will now be automatically synced with Collective once
                        they become available.
                    </Typography>

                    {/* Done Button */}
                    <Button variant="contained" color="primary" onClick={onClose} fullWidth sx={{ mt: 2 }}>
                        Done
                    </Button>
                </Stack>
            </DialogContent>
        </Dialog>
    );
}
